/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityPractitionerLinkModel } from '../../models/facility-practitioner-link-model';

export interface FacilityUnLinkPractitionerPost$Params {
      body?: FacilityPractitionerLinkModel
}

export function facilityUnLinkPractitionerPost(http: HttpClient, rootUrl: string, params?: FacilityUnLinkPractitionerPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, facilityUnLinkPractitionerPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PracticeStrictHttpResponse<void>;
    })
  );
}

facilityUnLinkPractitionerPost.PATH = '/Facility/UnLinkPractitioner';
